(ns teamoesterreich.user-mode.wana-help.tafel.checks
  (:require [clojure.string]
            ))




(defn check-wanado? [!actual-user]
  (or
    (get-in @!actual-user [:help :tafel_once])
    (get-in @!actual-user [:help :tafel_regular])
    (get-in @!actual-user [:help :tafel_driver])
    (get-in @!actual-user [:help :tafel_helper])
    (get-in @!actual-user [:help :tafel_deliverer])
    )
  )

(defn check-profile? [!actual-user]
  true)

(defn check-all? [!actual-user]
  (and
    (check-profile? !actual-user)
    (check-wanado? !actual-user)
    )
  )







